const buildRedirectUri = (path = '') =>
  `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }${path}`;

export default buildRedirectUri;
